/**
 * Typed boundary over the untyped `FetchApi` helpers.
 *
 * `fetchGet` / `fetchPost` resolve to `any` (they `JSON.parse` raw responses),
 * so this module is the single place where we assert the real response shapes.
 * Components and hooks consume strongly typed promises only.
 */
import ApiNames from "../constants/ApiNames";
import { apiClient } from "./NetworkService";
import type {
  ApiResponse,
  Category,
  Course,
  MostViewedVideo,
  OtpRequestResponse,
  SubscribeResponse,
} from "../types/home";

const getHeaders = (token?: string) => {
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};

export const getCategories = async (token?: string): Promise<ApiResponse<Category[]>> => {
  const res = await apiClient.get(ApiNames.categories, getHeaders(token));
  return res.data;
};

export const getCoursesByCategory = async (categoryId: number, token?: string): Promise<ApiResponse<Course[]>> => {
  const res = await apiClient.get(`${ApiNames.courseByCat}?category_id=${categoryId}`, getHeaders(token));
  return res.data;
};

export const getMostViewedVideos = async (token?: string): Promise<ApiResponse<MostViewedVideo[]>> => {
  const res = await apiClient.get(ApiNames.collar, getHeaders(token));
  return res.data;
};

export const requestOtp = async (msisdn: string, token?: string): Promise<ApiResponse<OtpRequestResponse>> => {
  const res = await apiClient.get(`${ApiNames.sendOtp}?msisdn=${msisdn}`, getHeaders(token));
  return res.data;
};

interface SubscribeParams {
  msisdn: string;
  userPackage: string;
  isActive: boolean;
  otp: string;
  token: string | null;
}

export const subscribe = async ({
  msisdn,
  userPackage,
  isActive,
  otp,
  token,
}: SubscribeParams): Promise<ApiResponse<SubscribeResponse>> => {
  const endpoint =
    `${ApiNames.subscribe}?msisdn=${parseInt(msisdn, 10)}` +
    `&level_id=1&name=Guest&subPackage=${userPackage}&login=${isActive}&otp=${otp}`;
  const res = await apiClient.post(endpoint, null, getHeaders(token ?? undefined));
  return res.data;
};
